module.exports = __webpack_public_path__ + "img/a_flutter_on_the_wind.f6f16694.jpg";